<template>
    <div>
        <div v-if="loading">
            <loader></loader>
        </div>
        <el-select filterable v-model="selected_empresa.id" @change="cambioEmpresa" clearable v-if="this.show_companies && !usuarioEmpresa"
            placeholder="Seleccionar empresa" no-data-text="No hay datos que coincidan"
            no-match-text="No hay datos que coincidan">
            <el-option v-for="(empresa, idx) in empresas" :key="idx" :label="empresa.nombre_empresa" :value="empresa.id">
            </el-option>
        </el-select>
        <div class="row mt-3" v-if="selected_empresa.id">
            <div class="col-12 text-center text-muted" v-if="cargando">
                <i class="fa fa-spin fa-spinner"> </i> Cargando campos personalizados
            </div>
            <div class="col-12 text-center text-muted" v-else-if="selected_empresa.id && !camposPersonalizados.length">
                <i class="fa fa-exclamation-triangle"></i> La empresa no tiene campos personalizados registrados
            </div>
            <div class="col-md-12 col-sm-12 col-lg-12" v-else-if="camposPersonalizados.length">
                <div class="table-responsive">
                    <table class="table table-striped table-sm table-bordered" style="color:#000;">
                        <tbody>
                            <tr v-for="(campo, idx) in camposPersonalizados" :key="idx">
                                <td>
                                    <p>{{ campo.campo }}</p>
                                </td>
                                <td>
                                    <b-textarea v-model="campo.valor"></b-textarea>
                                </td>
                                <td>
                                    <center>
                                        <el-tooltip v-if="!usuarioTecnico" effect="dark" placement="top"
                                            popper-class="py-1 px-2" content="Guardar">
                                            <b-btn
                                                @click="guardaCamposPersonalizados(selected_empresa.id, IdProducto, campo)"
                                                variant="primary" size="sm" class="mt-2">
                                                <i class="fa fa-save" />
                                            </b-btn>
                                        </el-tooltip>
                                    </center>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <center>
                        <b-button class="mt-2" v-if="!usuarioTecnico" variant="success" @click="saveFieldsCustom">
                            Guardar
                        </b-button>
                    </center>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import loader from "../../../containers/loader";

export default {
    name: 'CamposPerProductoEmpresa',
    props: {
        IdProducto: {
            type: Number,
            default: null,
            required: true
        },
        show_companies: {
            default: true,
            required: false
        }
    },
    data: function () {
        return {
            cargando: false,
            loading: false
        };
    },
    components: {
        loader
    },
    computed: {
        ...mapState('autenticacion', ['usuarioTecnico', 'usuarioEmpresa']),
        ...mapState('asignacionproductos', [
            'empresas',
            'selected_empresa',
            'ubicaciones',
            'camposPersonalizados',
            'info',
            'ubicacionesCantidad',
        ])
    },
    mounted() {
        if (this.selected_empresa.id) this.loadCompany();
    },
    methods: {
        ...mapActions('asignacionproductos', [
            'getUbicacionProd',
            'guardarCamposPer',
            'getCamposPersonalizados',
            'listarUbicacionesCantidad',
            'saveFieldsCustoms',
        ]),
        ...mapMutations('asignacionproductos', [
            'limpiarBasesAreasProd',
            'seleccionados',
            'setInfo',
            'setSeleccionados',
            'setUbicacionProducto',
            'seleccionados'
        ]),
        cambioEmpresa(id_empresa) {
            let empresa = this.empresas.find(e => e.id === id_empresa)

            if (empresa) {
                this.toggleVisibleEmp(empresa, this.IdProducto)
            }
        },
        async loadCompany(){
            await this.toggleVisibleEmp(this.selected_empresa,this.IdProducto)
        },

        async toggleVisibleEmp(empresa, producto) {
            await this.getCamposPersonalizados({ id_empresa: empresa.id, id_producto: this.IdProducto })
            let data = {}

            this.cargando = true

            data.empresa = empresa.id;
            data.producto = parseInt(producto);

            this.setInfo(data)
            await this.getUbicacionProd(this.info);
            await this.listarUbicacionesCantidad({
                company_id: empresa.id,
                product_id: this.IdProducto,
            })
            this.addItemsUbicacionesCantidad()
            this.setSeleccionados()
            await this.setChecked(this.ubicaciones)
            this.cargando = false
        },
        async setChecked(ubicacion) {
            await ubicacion.map(async i => {
                if (i.checked) {
                    this.seleccionados(i.id)
                }
                await this.setChecked(i.children)
            })
        },
        async guardaCamposPersonalizados(empresa, producto, campo) {
            this.loading = true;

            const info = {};

            info.id_empresa = empresa;
            info.producto = parseInt(producto);
            info.id = campo.id;
            info.campo = campo.campo;
            info.valor = campo.valor;

            await this.guardarCamposPer(info);
            this.loading = false;
        },

        addItemsUbicacionesCantidad() {
            this.ubicacionesCantidad.forEach((ele) => {
                if (!ele.get_product_ubicacion.get_product_ubicacion_quantity) {
                    ele.get_product_ubicacion.get_product_ubicacion_quantity = {
                        capacity: null,
                        quantity: null,
                        sys_list_unit_id: null,
                    }
                }
            })
        },

        async saveFieldsCustom() {
            await this.saveFieldsCustoms({
                company_id: this.selected_empresa.id,
                product_id: this.IdProducto,
                fields: this.camposPersonalizados,
            });
        }
    }
}
</script>
